import React from 'react'

import { Col, Span } from 'components'
import {
  InputLabelStyled,
  MenuItemStyled,
  SelectStyled,
  SelectStyles
} from 'components/Select/styles'
import { Controller } from 'react-hook-form'
import { COLORS, SPACING } from 'utils'

interface ISelectForm extends SelectStyles {
  errors?: any
  required?: boolean
  listOptions: any[]
  disableUnderline?: boolean
  placeholder?: string
  formValue?: string
  defaultValue?: string | number
  label?: string
  control: any
  labelMenu?: string
  valueMenu?: string | number
  disabled?: boolean
  allObject?: boolean
  hotfix?: boolean
  clearSelect?: boolean
}

const SelectForm: React.FC<ISelectForm> = ({
  hotfix,
  allObject,
  label = '\u00A0',
  formValue,
  control,
  clearSelect,
  listOptions,
  defaultValue = undefined,
  disableUnderline = false,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  placeholder = 'Selecione',
  required = false,
  labelMenu = 'label',
  valueMenu = 'value',
  width,
  errors,
  disabled
}) => {
  const formatLabel = () => label.charAt(0).toUpperCase() + label.slice(1)
  const hasError = errors && errors[formValue]
  const styleSelecione = clearSelect ? { cursor: 'pointer', opacity: 0.38 } : {}

  return (
    <Col
      marginTop={marginTop}
      marginRight={marginRight}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
    >
      <InputLabelStyled hasError={hasError}>{formatLabel()}</InputLabelStyled>
      <Controller
        defaultValue={defaultValue}
        name={formValue}
        control={control}
        rules={{ required: required }}
        render={({ field: { value, onChange } }) => (
          <SelectStyled
            renderValue={() => {
              let findValue
              if (allObject) {
                findValue = value ? value[valueMenu] : defaultValue
              } else {
                findValue = value ? value : defaultValue
              }
              const teste = listOptions?.find(
                (option) => option[valueMenu] === findValue
              )
              return teste ? teste[labelMenu] : ''
            }}
            value={value}
            defaultValue=""
            onChange={onChange}
            disableUnderline={disableUnderline}
            placeholder={placeholder}
            width={width}
            variant="standard"
            hasError={hasError}
            disabled={disabled}
          >
            <MenuItemStyled
              value={undefined}
              disabled={clearSelect ? false : true}
              style={styleSelecione}
            >
              {placeholder || 'Selecione'}
            </MenuItemStyled>
            {listOptions?.map((item, index) => (
              <MenuItemStyled
                value={allObject ? item : item[valueMenu]}
                key={`${index}-option`}
              >
                {item[labelMenu]}
              </MenuItemStyled>
            ))}
          </SelectStyled>
        )}
      />
      {hasError && (
        <Span
          text={
            hotfix ? 'Campo obrigatório' : errors[formValue]?.message || 'Erro'
          }
          color={COLORS.error}
          marginTop={SPACING.spacing5}
        />
      )}
    </Col>
  )
}

export default SelectForm
